import { usePaymentData } from '@p2p/entities/payment';

import { TransferCanceled } from './TransferCanceled';

export const TransferCanceledPage = () => {
  const { order } = usePaymentData();

  return <TransferCanceled order={order} />;
};
